import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default class ButtonGroup extends React.PureComponent {
    static propTypes = {
        /** One or more buttons */
        children: PropTypes.node.isRequired,
        
        /** The horizontal alignment of the buttons */
        align: PropTypes.oneOf([ 'left', 'right', 'center' ]),
        
        /** Makes buttons 100% wide at xs and sm breakpoints */
        isFullWidthOnMobile: PropTypes.bool,
        
        /** Makes buttons stretch horizontally to fill the container */
        isStretchedToFit: PropTypes.bool,
        
        /** Custom class added to existing classes */
        className: PropTypes.string
    }
    
    static defaultProps = {
        isFullWidthOnMobile: true,
        isStretchedToFit: false,
        align: 'left'
    }
    
    render() {
        const {
            children,
            isFullWidthOnMobile,
            align,
            isStretchedToFit,
            className,
            ...rest
        } = this.props;
        
        const classes = cx('sarsa-button-group', {
            'is-full-width-on-mobile': isFullWidthOnMobile,
            'align-right': align === 'right',
            'align-center': align === 'center',
            'is-stretched-to-fit': isStretchedToFit,
            [className]: className
        });
        
        return (
            <div
                className={classes}
                data-component="ButtonGroup"
                {...rest}>
                {children}
            </div>
        );
    }
}